/**
 * Próximo passo depois de senha válida (vide spec 2026-08-21):
 * - "totp": conta tem fator verificado → desafio na própria página de login;
 * - "setup": CLIENT sem fator → interstitial /configurar-2fa (todo login);
 * - "app": segue pro destino (admin sem fator, ou role indeterminável).
 */
export function postLoginStep(
  role: string | null | undefined,
  hasTotp: boolean
): "totp" | "setup" | "app" {
  if (hasTotp) return "totp";
  return role === "CLIENT" ? "setup" : "app";
}
